import React, { ReactNode, ChangeEventHandler } from 'react';
import classNames from 'classnames';

type Props = {
  id?: string;
  label?: string | ReactNode;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  size?: string;
};

const Switch = (props: Props) => {
  const { id = 'switch', label, checked, onChange, size } = props;

  return (
    <label className="inline-flex items-center cursor-pointer">
      <input
        id={id}
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
      />
      <div
        className={classNames(
          "relative bg-gray-200 rounded-full peer peer-focus:ring-2 peer-focus:ring-gray-300 dark:peer-focus:ring-gray-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-gray-600 peer-checked:bg-gray-600",
          {
            'w-9 h-5 after:top-[2px] after:start-[2px] after:h-4 after:w-4':
              size === 'sm',
            'w-11 h-6 after:top-[2px] after:start-[2px] after:h-5 after:w-5':
              !size || size === 'md',
            'w-14 h-7 after:top-0.5 after:start-[4px] after:h-6 after:w-6':
              size === 'lg',
          },
        )}
      />

      {label && (
        <span className="ml-4 text-sm font-medium text-gray-900 dark:text-gray-300">
          {label}
        </span>
      )}
    </label>
  );
};

export default Switch;
